import axiosInstance from './axiosInstance';

export const fetchUserDetails = async (userId) => {
  // console.log('Fetching user details for userId (email):', userId);
  try {
    const response = await axiosInstance.get(`/users/${userId}`);  
    // console.log('User details API response:', response);
    return response;
  } catch (error) {
    console.error('Error in fetchUserDetails:', error);
    throw error;
  }
};
